import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SITE_SURVEYS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('SITE_SURVEYS');
export const SITE_SURVEYS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SITE_SURVEYS_CRUD_ACTION_CONSTANTS
);
